"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var moment = require("moment");
var SupportPortalTemplates_1 = require("../../../SupportPortalTemplates");
var Notification_1 = require("../../Notification");
var Confirmation_1 = require("../../Confirmation");
var VisibleNote = /** @class */ (function (_super) {
    __extends(VisibleNote, _super);
    function VisibleNote(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.setEditableNoteValues = function () {
            _this.props.setEditableNoteId(_this.props.note.id);
            _this.props.setEditableNoteText(_this.props.note.text);
        };
        _this.deleteNote = function () {
            if (_this.supportPortalTemplates.userHasRole(["Administrator", "Fraud"])) {
                _this.setState({ showConfirmation: true });
            }
            else {
                _this.setState({ showAlert: true });
            }
        };
        _this.doDelete = function () {
            _this.supportPortalService.deleteNote(_this.props.customerReferenceNumber, _this.props.note.id).subscribe(function (note) {
                console.log("Deleted note:", _this.props.note);
                _this.props.updateNotes();
            });
        };
        _this.state = {
            showAlert: false,
            showConfirmation: false
        };
        return _this;
    }
    VisibleNote.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "note", children: [(0, jsx_runtime_1.jsx)("div", { className: "note-text", children: this.props.note.text }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: "note-created", children: [(0, jsx_runtime_1.jsxs)("div", { children: ["Created by: ", this.props.note.createdBy.fullName] }), (0, jsx_runtime_1.jsxs)("div", { children: ["Created on: ", moment(this.props.note.createdOn).format("DD/MM/YYYY, HH:mm")] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "note-edit", children: [(0, jsx_runtime_1.jsx)("a", { className: "far fa-edit note-icon", title: "Edit", onClick: this.setEditableNoteValues }), (0, jsx_runtime_1.jsx)("a", { className: "far fa-trash-alt note-icon", title: "Remove", onClick: this.deleteNote }), (0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.showAlert, hide: function () { return _this.setState({ showAlert: false }); }, title: "You are not permitted to delete notes!", message: "" }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: this.state.showConfirmation, hide: function () { return _this.setState({ showConfirmation: false }); }, confirm: this.doDelete, title: "", message: "Are you sure you want to REMOVE this note?" })] })] })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], VisibleNote.prototype, "supportPortalService", void 0);
    VisibleNote = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], VisibleNote);
    return VisibleNote;
}(React.Component));
exports.default = VisibleNote;
//# sourceMappingURL=VisibleNote.js.map